<template>
	<div
		class="vx-row center-content"
		style="justify-content: center; position: relative"
	>
		<div
			class="flex center"
			@mouseenter="onLeadIconHover(index, true)"
			@mouseleave="onLeadIconHover(index, false)"
		>
			<!-- Tooltip that shows/hides based on hover -->
			<!-- <div
				v-if="showTooltip && showLeadMessageIconIndex == index"
				:style="tooltipStyle"
			>
				{{ $props.user.name }}
			</div> -->

			<vs-button
				v-if="showLeadMessageIcon && showLeadMessageIconIndex == index"
				size="large"
				color="primary"
				type="flat"
				icon-pack="feather"
				icon="icon-message-square"
				@click="displayNotePadPopup($props.contract, $props.user)"
			>
			</vs-button>

			<vs-avatar
				style="border: 1px solid"
				:text="$props.user.name"
				:src="getCollaboratorAvatar($props.user.users_id)"
				v-else
			/>
		</div>
	</div>
</template>
  
  <script>
import Vue from "vue";
import store from "@/store/store";
import NotepadPopup from "@/components/popups/NotepadPopup.vue";

export default {
	name: "AvatarMessageChip",
	props: {
		/**
		 * @param {Number} users_id - The user id
		 * @param {String} contract - The contract object
		 */
		user: {
			type: Object,
			default: {},
		},
		/**
		 *  @param {Number} id - The contract object
		 * @param {Number} society_id - The soceity id
		 */
		contract: {
			type: Object,
			default: {},
		},
	},
	components: { NotepadPopup },
	data() {
		return {
			showLeadMessageIcon: false,
			showLeadMessageIconIndex: null,
			showNotepadPopup: false,
			showTooltip: false,
			tooltipStyle: {
				position: "absolute",
				top: "-30px", // Adjust the position as needed
				left: "50%",
				transform: "translateX(-50%)",
				padding: "5px 10px",
				backgroundColor: "#333",
				color: "#fff",
				borderRadius: "4px",
				whiteSpace: "nowrap",
				zIndex: "500",
			},
		};
	},

	computed: {
		allCollaboratorsAvatar: () => {
			return store.state.collaborators_avatar;
		},
	},

	methods: {
		onLeadIconHover(index, isHover) {
			this.showLeadMessageIcon = isHover;
			this.showLeadMessageIconIndex = index;

			// Show/hide tooltip based on hover state
			this.showTooltip = isHover;
		},
		displayNotePadPopup(contract, user) {
			// Initialisation des données pour le popup
			this.showNotepadPopup = true;
			// Instancie la class SocietyInfoPopup pour mount sur la balise div principale
			let ComponentClass = Vue.extend(NotepadPopup);
			let notepadPopup = new ComponentClass({
				propsData: {
					contract_id: contract.id,
					popupActive: this.showNotepadPopup,
					router: this.$router,
					apiUrl: this.apiUrl,
					zIndex: 999999,
					society_id: contract.society_id,
					destinationUserId: Number(user.users_id) || user.users_id,
				},
			});
			notepadPopup.$mount();
			this.$refs.popupContainer.appendChild(notepadPopup.$el);
			notepadPopup.$on("close-popup", (data) => {
				this.showNotepadPopup = false;
			});
		},
		getCollaboratorAvatar(userId) {
			let foundAvatar = this.allCollaboratorsAvatar.find(
				(avatar) => avatar.id == userId
			);
			if (foundAvatar) return foundAvatar.avatar;
			else return null;
		},
		closeNotePopUp() {
			this.showNotepadPopup = false;
		},
	},
};
</script>
  
  <style scoped>
</style>
  